/* ---- product info ---- */
if (!customElements.get("product-info")) {
  customElements.define("product-info", class $ extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".quantity__input");
      this.currentVariant = this.querySelector(".product-variant-id");
      this.variantSelects = this.querySelector("variant-radios");
      this.submitButton = this.querySelector("[type=\"submit\"]");
      this.form = this.querySelector("#ProductForm-" + this.dataset.section);
      this.hasUrl = this.dataset.url !== null;
    }
    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    connectedCallback() {
      if (this.form && this.input) {
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (this.quantityForm) {
          this.setQuantityBoundries();
          if (!this.dataset.originalSection) {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
          }
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, t => {
            let e = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
            if (t.data.sectionId === e) {
              this.updateQuantityRules(t.data.sectionId, t.data.html);
              this.setQuantityBoundries();
            }
          });
        }
      }
    }
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }
    setQuantityBoundries() {
      let t = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      };
      let x = t.min;
      let e = t.max === null ? t.max : t.max - t.cartQuantity;
      if (e !== null) {
        x = Math.min(x, e);
      }
      if (t.cartQuantity >= t.min) {
        x = Math.min(x, t.step);
      }
      let i = parseInt(this.input.value) || x;
      let s = i;
      if (s < x) {
        s = x;
      }
      if (e !== null && s > e) {
        s = e;
      }
      this.input.min = x;
      this.input.max = e;
      this.input.value = s;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
    initShareLinks() {
      let t = this.querySelector(".share-url-button");
      if (!t) {
        this.shareUrl = true;
      }
    }
    fetchQuantityRules() {
      if (this.currentVariant && this.currentVariant.value) {
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
        fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(t => t.text()).then(t => {
          let e = new DOMParser().parseFromString(t, "text/html");
          this.updateQuantityRules(this.dataset.section, e);
          this.setQuantityBoundries();
        }).catch(t => {
          console.error(t);
        }).finally(() => {
          this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
        });
      }
    }
    updateQuantityRules($, t) {
      let e = t.getElementById("Quantity-Form-" + $);
      if (e && this.quantityForm) {
        let i = [".quantity__input", ".quantity__rules", ".quantity__label"];
        for (let s of i) {
          let a = this.quantityForm.querySelector(s);
          let r = e.querySelector(s);
          if (a && r) {
            if (s === ".quantity__input") {
              let n = ["data-cart-quantity", "data-min", "data-max", "step"];
              for (let l of n) {
                let h = r.getAttribute(l);
                if (h !== null) {
                  a.setAttribute(l, h);
                }
              }
            } else {
              a.innerHTML = r.innerHTML;
            }
          }
        }
      }
    }
  });
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach($ => {
  $.setAttribute("role", "button");
  $.setAttribute("aria-expanded", $.parentNode.hasAttribute("open"));
  if ($.nextElementSibling?.getAttribute("id")) {
    $.setAttribute("aria-controls", $.nextElementSibling.id);
  }
  $.addEventListener("click", $ => {
    $.currentTarget.setAttribute("aria-expanded", !$.currentTarget.closest("details").hasAttribute("open"));
  });
  if (!$.closest("header-drawer")) {
    $.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
});
